import { AppRoute } from '@agentselly/immodossier-shared';
import { cockpitActivitiesWidgets } from '~/config/widgets/cockpit/cockpitActivitiesWidgets';
import { makeQueryLoaderWidgetsRoute } from '~/helper/makeQueryLoaderWidgetsRoute';

export const Route = makeQueryLoaderWidgetsRoute(
  AppRoute.$LANG_$COMPANYID_PUBLIC_DEMO_COCKPIT_ACTIVITIES,
  cockpitActivitiesWidgets,
  true,
);
